const bootstrapColors = [
	{ name: 'Primary Color', color: '#084298' },
	{ name: 'Primary Color Border', color: '#b6d4fe' },
	{ name: 'Primary Color Accent', color: '#26559c' },
	{ name: 'Primary Color Light', color: '#cfe2ff' },

	{ name: 'Secondary Color', color: '#41464b' },
	{ name: 'Secondary Color Border', color: '#d3d6d8' },
	{ name: 'Secondary Color Accent', color: '#5c6874' },
	{ name: 'Secondary Color Light', color: '#e2e3e5' },

	{ name: 'Success Color', color: '#0f5132' },
	{ name: 'Success Color Border', color: '#badbcc' },
	{ name: 'Success Color Accent', color: '#167247' },
	{ name: 'Success Color Light', color: '#d1e7dd' },

	{ name: 'Danger Color', color: '#842029' },
	{ name: 'Danger Color Border', color: '#f5c2c7' },
	{ name: 'Danger Color Accent', color: '#832e35' },
	{ name: 'Danger Color Light', color: '#f8d7da' },

	{ name: 'Warning Color', color: '#664d03' },
	{ name: 'Warning Color Border', color: '#ffecb5' },
	{ name: 'Warning Color Accent', color: '#7f6002' },
	{ name: 'Warning Color Light', color: '#fff3cd' },

	{ name: 'Info Color', color: '#055160' },
	{ name: 'Info Color Border', color: '#b6effb' },
	{ name: 'Info Color Accent', color: '#076c81' },
	{ name: 'Info Color Light', color: '#cff4fc' },

	{ name: 'Light Color', color: '#636464' },
	{ name: 'Light Color Border', color: '#fdfdfe' },
	{ name: 'Light Color Accent', color: '#7b7c7c' },
	{ name: 'Light Color Light', color: '#fefefe' },

	{ name: 'Dark Color', color: '#141619' },
	{ name: 'Dark Color Border', color: '#bcbebf' },
	{ name: 'Dark Color Accent', color: '#292d33' },
	{ name: 'Dark Color Light', color: '#d3d3d4' },
];
export default bootstrapColors;
